import { gql } from '@apollo/client';

export const GET_BAKER_USER_BY_EMAIL = gql`
  query GetBakerUserByEmail($email: String!) {
    bakerUserByEmail(email: $email) {
      email
      profile
      inventory
      loans
      lseg
      dailyPricing
      reports
      portfolios
      cashFlows
      swapIQ
      houstonTrust
      empyreanImport
      yieldBookMonitor
    }
  }
`;
